const validate = {
  rules: {
    categoria_id: {
      required: true,
    },
    nome: {
      required: true,
    },
  },
  messages: {
    categoria_id: "A categoria é obrigatória.",
    nome: "O nome é obrigatório.",
  },
};

export default validate;
